












































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Ref } from 'vue-property-decorator';
import { Department, departmentApis, Employee, employeeAdminApis } from '../../api';
import EmployeeEditDialog from './EmployeeEditDialog.vue';
import * as _ from 'lodash';
import Pagination from '@/components/Pagination.vue';
import SearchHeader from '@/components/SearchHeader.vue';

declare const CANNOT_RESET_PASSWD: boolean;

@Component({ components: { EmployeeEditDialog, Pagination, SearchHeader } })
export default class EmployeeList extends Vue {
  readonly cannotResetPassword = CANNOT_RESET_PASSWD;
  @Ref('employee-edit-dialog') employeeEditDialog!: EmployeeEditDialog;

  total = 0;
  page = 1;
  pageSize = 10;
  employees: Array<Employee> = [];
  loading = false;
  search = '';
  companyFilter: number | null = null;
  companies: Array<Department> = [];
  debounceSearch!: (name: string) => void;

  created() {
    this.debounceSearch = _.debounce(name => {
      if (name.trim() != '@') {
        return this.showPage(1);
      }
    }, 200);
  }

  async mounted() {
    await this.showPage(1);
  }

  async refresh() {
    this.companyFilter = null;
    this.search = '';
    await this.showPage(1);
  }

  async showPage(page: number) {
    this.loading = true;
    this.employees = [];
    this.page = page;
    try {
      const result = await employeeAdminApis.search({
        name: this.search.trim(),
        departmentId: this.companyFilter,
        limit: this.pageSize,
        skip: (this.page - 1) * this.pageSize
      });
      this.employees = result.employees;
      this.companies = result.companies;
      this.total = result.total;
    } finally {
      this.loading = false;
    }
  }

  async findDepartment(companyFilter: any) {
    this.companyFilter = companyFilter;
    this.companies = await departmentApis.search(companyFilter);
  }

  getDepartmentId() {
    return this.companyFilter;
  }

  getEmployeeSearchName() {
    return this.search.trim();
  }

  departmentColumn(departments: Array<Department>): string {
    if (departments) {
      return departments[departments.length - 1].name;
    }
    return '';
  }

  departmentTooltip(departments: Array<Department>): string {
    if (departments) {
      return departments.map(d => d.name).join(' / ');
    }
    return '';
  }

  async createEmployee() {
    await this.employeeEditDialog.show(null);
    this.search = '';
    this.companyFilter = null;
    this.showPage(1);
  }

  async editEmployee(employee: Employee) {
    const newEmployee = await this.employeeEditDialog.show(employee);
    const idx = this.employees.findIndex(e => e.id === newEmployee.id);
    if (idx >= 0) {
      Vue.set(this.employees, idx, newEmployee);
    }
  }

  async deleteEmployee(employee: Employee) {
    await employeeAdminApis.delete(employee.id);
    this.$notify.success(`删除用户[${employee.display_name}]成功`);
    const idx = this.employees.findIndex(e => e.id === employee.id);
    if (idx >= 0) {
      this.employees.splice(idx, 1);
    }
  }

  async resetPassword(employee: Employee) {
    await employeeAdminApis.resetPassword(employee.id);
    this.$notify.success(`重置用户[${employee.display_name}]的密码成功`);
  }

  async syncDingtalkOne(employee: Employee) {
    await employeeAdminApis.syncDingtalkOne(employee.id);
    this.$notify.success(employee.display_name + '钉钉数据同步成功');
    this.showPage(this.page);
  }

  async changeEmpLoginPerm(allow_login: boolean, employee: Employee) {
    await employeeAdminApis.put_login_perm(employee.id, allow_login);
    this.$notify.success(employee.display_name + '修改成功');
  }
}
